"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import WaveGroupEdit from "./WaveGroupEdit";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { WaveGroupType } from "../WaveGroup.types";
import type { ApiUpdateWaveRequest } from "@/generated/models/ApiUpdateWaveRequest";
export type WaveGroupEditButtonHandle = {
  open: () => void;
};
interface WaveGroupEditButtonProps {
  readonly wave: ApiWave;
  readonly type: WaveGroupType;
  readonly onWaveUpdate: (body: ApiUpdateWaveRequest, opts?: {
    readonly skipAuth?: boolean | undefined;
  }) => Promise<void>;
  readonly renderTrigger?: ((options: {
    readonly open: () => void;
  }) => ReactNode) | null | undefined;
}
const WaveGroupEditButton = forwardRef<WaveGroupEditButtonHandle, WaveGroupEditButtonProps>(function WaveGroupEditButton(t0, ref) {
  const $ = _c(16);
  const {
    wave,
    type,
    onWaveUpdate,
    renderTrigger
  } = t0;
  const [isEditOpen, setIsEditOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsEditOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpen = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => ({
      open: handleOpen
    });
    t3 = [handleOpen];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useImperativeHandle(ref, t2, t3);
  let triggerContent;
  if (renderTrigger) {
    let t4;
    if ($[3] !== renderTrigger) {
      t4 = renderTrigger({
        open: handleOpen
      });
      $[3] = renderTrigger;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    triggerContent = t4;
  } else {
    if (renderTrigger === null) {
      triggerContent = null;
    } else {
      let t4;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <button type="button" aria-label="Edit group" title="Edit" onClick={handleOpen} className="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg tw-border-none tw-bg-transparent tw-p-0 tw-text-iron-500 tw-transition-all tw-duration-300 tw-ease-out hover:tw-bg-iron-800 hover:tw-text-iron-300"><FontAwesomeIcon icon={faPen} className="tw-h-4 tw-w-4" /></button>;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      triggerContent = t4;
    }
  }
  let t4;
  if ($[6] !== onWaveUpdate) {
    t4 = async body => {
      await onWaveUpdate(body);
      setIsEditOpen(false);
    };
    $[6] = onWaveUpdate;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isEditOpen || $[9] !== t4 || $[10] !== type || $[11] !== wave) {
    t5 = <WaveGroupEdit wave={wave} isEditOpen={isEditOpen} type={type} setIsEditOpen={setIsEditOpen} onWaveUpdate={t4} />;
    $[8] = isEditOpen;
    $[9] = t4;
    $[10] = type;
    $[11] = wave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5 || $[14] !== triggerContent) {
    t6 = <>{triggerContent}{t5}</>;
    $[13] = t5;
    $[14] = triggerContent;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});
export default WaveGroupEditButton;